import React from 'react';
import PropTypes from 'prop-types';
import { IonSpinner } from '@ionic/react';
import HideImageIcon from '@mui/icons-material/HideImage';
import { MEDIA_TYPES } from '../constants';
import useInstagramMedia from '../hooks/useInstagramMedia';
import text from './text.json';
import {
  MediaItemWrapper, MediaItemError, MediaItemUnavailable, MediaItemUnavailableFrame,
  MediaImage, MediaVideo,
} from './styles';

const InstagramMediaItem = ({ media }) => {
  const { id, mediaType, mediaUrl: instagramMediaUrl } = media;
  const { mediaUrl: storedMediaUrl, isLoading, error } = useInstagramMedia(id);

  // Instagram omits media_url when it withholds a post's file, usually a copyright flag.
  // For a video the server stores the thumbnail frame in its place, so there may still be
  // something to show — but it is a cover image, not the video.
  const isWithheldByInstagram = !instagramMediaUrl;
  const withheldFrameUrl = isWithheldByInstagram ? storedMediaUrl : null;
  const showError = !isWithheldByInstagram && !!error;
  const showMedia = !isWithheldByInstagram && !error && !!storedMediaUrl;

  return (
    <MediaItemWrapper>
      {isLoading && <IonSpinner name="crescent" />}
      {!isLoading && isWithheldByInstagram && (
        <MediaItemUnavailable>
          {withheldFrameUrl ? (
            <MediaItemUnavailableFrame src={withheldFrameUrl} alt={text.mediaUnavailableFrameAlt} />
          ) : (
            <HideImageIcon fontSize="large" />
          )}
          {withheldFrameUrl ? text.mediaUnavailableWithFrame : text.mediaUnavailable}
        </MediaItemUnavailable>
      )}
      {!isLoading && showError && (
        <MediaItemError>
          {text.mediaLoadError}
          {' '}
          {error.message}
        </MediaItemError>
      )}
      {!isLoading && showMedia && (
        <>
          {mediaType === MEDIA_TYPES.IMAGE && <MediaImage src={storedMediaUrl} alt="media" />}
          {mediaType === MEDIA_TYPES.VIDEO && (
            <MediaVideo controls>
              <source src={storedMediaUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </MediaVideo>
          )}
        </>
      )}
    </MediaItemWrapper>
  );
};

InstagramMediaItem.propTypes = {
  media: PropTypes.shape({
    id: PropTypes.string.isRequired,
    mediaType: PropTypes.oneOf([MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO]).isRequired,
    mediaUrl: PropTypes.string,
  }).isRequired,
};

export default InstagramMediaItem;
